import {useEffect, useRef, useState} from 'react'
import {useLocation, useMatch, useNavigate} from 'react-router-dom'

import {useErrorHandler} from '../../../_metronic/helpers/ErrorHandler'
import {useIsMobile} from '../../shared/responsive'
import * as GisDataAdapter from './Fields/services/GisDataAdapter'
import FieldModuleOnboardingCallout from './Fields/FieldModuleOnboardingCallout'
import {useGisContext} from './GisContext'

const GIS_ROOT_PATHS = new Set(['/gis', '/gis/'])

const GisFieldsBootstrap = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useIsMobile()
  const {errorHandler} = useErrorHandler()
  const {openPanel} = useGisContext()
  const isOnFieldList = Boolean(useMatch('/gis/field/list'))
  const [fields, setFields] = useState([])
  const [loading, setLoading] = useState(true)
  const [calloutDismissed, setCalloutDismissed] = useState(false)
  const hasFetchedFields = useRef(false)
  const wasOnFieldList = useRef(false)
  const hasRedirectedToFieldList = useRef(false)

  useEffect(() => {
    const enteredFieldList = isOnFieldList && !wasOnFieldList.current
    wasOnFieldList.current = isOnFieldList

    if (hasFetchedFields.current && !enteredFieldList) {
      return
    }

    hasFetchedFields.current = true
    let ignore = false

    setLoading(true)
    errorHandler(GisDataAdapter.listFields()).then((res) => {
      if (ignore) {
        return
      }

      if (res?.ok) {
        setFields(res.data || [])
      } else {
        setFields([])
      }

      setLoading(false)
    })

    return () => {
      ignore = true
    }
    // errorHandler identity changes every render; fetch on mount and when entering field list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnFieldList])

  useEffect(() => {
    if (loading || !GIS_ROOT_PATHS.has(location.pathname) || hasRedirectedToFieldList.current) {
      return
    }

    hasRedirectedToFieldList.current = true
    navigate('/gis/field/list', {replace: true})

    if (isMobile) {
      openPanel()
    }
  }, [isMobile, loading, location.pathname, navigate, openPanel])

  useEffect(() => {
    if (!isMobile || loading || fields.length > 0 || !isOnFieldList) {
      return
    }

    openPanel()
  }, [fields.length, isMobile, isOnFieldList, loading, openPanel])

  const shouldShowCallout = !loading
    && fields.length < 1
    && isOnFieldList
    && !calloutDismissed

  if (!shouldShowCallout) {
    return null
  }

  if (isMobile) {
    return null
  }

  return (
    <FieldModuleOnboardingCallout
      anchorId='gis-field-module-card'
      onDismiss={() => setCalloutDismissed(true)}
    />
  )
}

export default GisFieldsBootstrap
